module.exports = "/_next/static/chromiums/og-1200x630-products-passionfruit-mango-lip-balm-13079643089509d48b52df34fdb61875.jpg";